import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import keys from './keys';
import config from '../../../../config';

const useGetEpisodeAudioEncoderData = ({ episodeAudioUrl, disabled } = {}) => {
  const { showId, episodeId } = useParams();

  const query = useQuery({
    queryKey: keys(showId).encoder(episodeId, episodeAudioUrl),
    queryFn: async () => {
      const res = await axios.get(`${config.sphinxEncoder}/file?url=${episodeAudioUrl}`);
      return res.data;
    },
    enabled: Boolean(episodeAudioUrl) && !disabled,
    refetchInterval: (result) => {
      const isProcessing = result?.status === 'queued' || result?.status === 'processing';
      if (isProcessing) {
        return 5000; // poll every 5 seconds
      }
      return false;
    },
    refetchOnMount: (result) => {
      const isProcessing = result?.status === 'queued' || result?.status === 'processing';

      if (isProcessing) {
        return 'always'; // the query will always refetch on mount if the data is processing
      }
      return false; // the query will not refetch on mount if the data is not processing
    },
  });

  return {
    encoderData: query.data,
    encoderDataError: query.error,
    isEncoderDataFetchError: query.isError,
    isEncoderDataFetchSuccess: query.isSuccess,
    isEncoderDataFetching: query.isFetching,
    isEncoderDataLoading: query.isInitialLoading,
    ...query,
  };
};

useGetEpisodeAudioEncoderData.propTypes = {
  episodeAudioUrl: PropTypes.string,
  disabled: PropTypes.bool,
};

export default useGetEpisodeAudioEncoderData;
